import { MessageCircle } from "lucide-react";
import { COLLECTION, buildWhatsAppUrl } from "../data/watches";
import { Reveal } from "./Reveal";

const ProductCard = ({ watch, index }) => {
  const message = `Hola Romero Watches, me interesa el modelo "${watch.name}" (${watch.series}) — ${watch.price}. ¿Me podéis dar más información?`;

  return (
    <Reveal
      delay={index * 80}
      className="product-card-rw group flex flex-col"
    >
      <div className="relative w-full aspect-[4/5] mb-6 overflow-hidden bg-[var(--brand-surface)]">
        <img
          src={watch.image}
          alt={watch.name}
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/80 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500" />

        <span className="absolute top-5 left-5 font-accent-rw text-[9px] uppercase tracking-[0.3em] text-[var(--brand-gold)]/90 bg-[#050B14]/40 backdrop-blur-md px-3 py-1.5 border border-white/5">
          {watch.series}
        </span>

        <a
          href={buildWhatsAppUrl(message)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`product-whatsapp-${watch.id}`}
          aria-label={`Pedir ${watch.name} por WhatsApp`}
          className="product-cta-rw absolute bottom-5 left-5 right-5 inline-flex items-center justify-center gap-2 py-3.5 bg-[var(--brand-whatsapp)] text-black hover:bg-[var(--brand-whatsapp-dark)] hover:text-white transition-all duration-300 text-[10px] uppercase tracking-[0.28em] font-semibold opacity-0 translate-y-2"
        >
          <MessageCircle size={14} strokeWidth={2} />
          Pedir por WhatsApp
        </a>
      </div>

      <div className="flex items-baseline justify-between gap-4">
        <h3 className="font-serif-rw text-2xl sm:text-3xl text-slate-50 leading-tight">
          {watch.name}
        </h3>
        <span className="font-accent-rw text-sm tracking-[0.15em] text-[var(--brand-gold)] whitespace-nowrap">
          {watch.price}
        </span>
      </div>
      <p className="mt-3 text-sm text-slate-400 leading-relaxed font-light">
        {watch.description}
      </p>

      {/* Mobile-friendly cta visible always under text */}
      <a
        href={buildWhatsAppUrl(message)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`product-card-link-${watch.id}`}
        className="mt-5 inline-flex items-center gap-2 self-start font-accent-rw text-[10px] uppercase tracking-[0.3em] text-slate-300 hover:text-[var(--brand-gold)] transition-colors sm:hidden"
      >
        Consultar disponibilidad
        <span className="w-6 h-px bg-current" />
      </a>
    </Reveal>
  );
};

export const Collection = () => {
  return (
    <section
      id="coleccion"
      data-testid="collection-section"
      className="relative py-24 sm:py-36 px-6 sm:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-20 sm:mb-28 items-end">
          <Reveal className="lg:col-span-7">
            <div className="font-accent-rw text-[11px] uppercase tracking-[0.4em] text-[var(--brand-gold)] mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-[var(--brand-gold)]" />
              La colección · Originales Pagani, Wishdoit & Specht Söhne
            </div>
            <h2 className="font-serif-rw text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-slate-50">
              Los modelos más deseados de las <em className="italic text-[var(--brand-gold)] font-light">mejores microbrands</em>.
            </h2>
          </Reveal>
          <Reveal delay={120} className="lg:col-span-5">
            <p className="text-base sm:text-lg text-slate-400 leading-relaxed font-light">
              Trabajamos con las marcas que están redefiniendo la relojería
              premium accesible: <strong className="text-slate-200 font-normal">Pagani Design</strong>,{" "}
              <strong className="text-slate-200 font-normal">Wishdoit</strong> y{" "}
              <strong className="text-slate-200 font-normal">Specht & Söhne</strong>. Movimientos
              automáticos japoneses, acero 316L, cristal de zafiro y
              resistencia al agua garantizada en cada pieza.
            </p>
          </Reveal>
        </div>

        <div
          data-testid="collection-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-20"
        >
          {COLLECTION.map((w, i) => (
            <ProductCard key={w.id} watch={w} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Collection;
